/**
 * Social-proof metrics strip — bold numbers inside a curved gradient card.
 * GoGrabJob differentiators surfaced as scannable stats.
 */

import { motion } from 'framer-motion';
import { landingSectionY } from './landingCtaStyles';

const METRICS = [
  {
    value: '10x',
    label: 'Faster screening',
    detail: 'vs. manual resume review',
  },
  {
    value: '94%',
    label: 'AI interview accuracy',
    detail: 'structured rubric scoring',
  },
  {
    value: '100%',
    label: 'Audit trail coverage',
    detail: 'every recruiter action logged',
  },
  {
    value: '50%',
    label: 'Less time-to-submit',
    detail: 'from apply to panel stage',
  },
] as const;

export function B2BMetricsStrip() {
  return (
    <section className={`px-2 sm:px-4 ${landingSectionY}`}>
      <motion.div
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
        className="relative mx-auto max-w-[90rem] overflow-hidden rounded-[1.25rem]"
        style={{
          background: 'linear-gradient(135deg, #7B6EE8 0%, #8E86FF 55%, #b0a9ff 100%)',
        }}
      >
        {/* Subtle blob */}
        <div
          className="pointer-events-none absolute -left-10 -top-10 h-36 w-36 rounded-full opacity-20 blur-2xl"
          style={{ background: '#6B5FD8' }}
          aria-hidden
        />

        <div className="relative z-10 grid grid-cols-2 gap-y-0 px-6 py-3 sm:px-10 sm:py-4 md:grid-cols-4">
          {METRICS.map(({ value, label, detail }, i) => (
            <div
              key={value}
              className={`flex flex-col items-center justify-center px-4 py-2 text-center sm:px-6 md:py-0 ${
                i < METRICS.length - 1 ? 'md:border-r md:border-white/20' : ''
              } ${i % 2 === 0 && i < 2 ? 'max-md:border-b max-md:border-white/15' : ''}`}
            >
              <span className="text-[1.9rem] font-extrabold tabular-nums leading-none text-white sm:text-[2.1rem]">
                {value}
              </span>
              <span className="mt-0.5 text-[12px] font-semibold leading-tight text-white/90">
                {label}
              </span>
              <span className="mt-0.5 text-[10px] font-normal leading-snug text-white/55">
                {detail}
              </span>
            </div>
          ))}
        </div>
      </motion.div>
    </section>
  );
}
